export default __webpack_public_path__ + "static/media/27.8f6e11a6.jpeg";